/**
 * Relationships app — /apps/relationships/*
 *
 * One job: a PM wants to see AI-suggested connections and confirm how items
 * link before ranking. Two screens (C Mode):
 *   /              AI suggestions — pending Nexus proposals
 *   /:itemId       Connections — edges for one item + provenance on peers
 *
 * Writes go through nexusRelationshipStore + itemRelationshipsStore. No new schema.
 */

import { Navigate, Route, Routes } from 'react-router-dom';
import { getAppDefinition } from '../registry';
import { RequireAppAccess } from '../RequireAppAccess';
import RelationshipsQueueScreen from './RelationshipsQueueScreen';
import RelationshipsItemScreen from './RelationshipsItemScreen';

export default function RelationshipsApp() {
  const app = getAppDefinition('relationships')!;
  return (
    <RequireAppAccess app={app}>
      <Routes>
        <Route index element={<RelationshipsQueueScreen />} />
        <Route path=":itemId" element={<RelationshipsItemScreen />} />
        <Route path="*" element={<Navigate to="/apps/relationships" replace />} />
      </Routes>
    </RequireAppAccess>
  );
}
